import HeaderContainer_AfterScrollComponent from '@wix/thunderbolt-elements/src/components/HeaderContainer/viewer/skinComps/AfterScroll/AfterScroll.skin';
import HeaderContainer_AfterScrollController from '@wix/thunderbolt-elements/src/components/HeaderContainer/viewer/HeaderContainer.controller';


const HeaderContainer_AfterScroll = {
  component: HeaderContainer_AfterScrollComponent,
  controller: HeaderContainer_AfterScrollController
};


export const components = {
  ['HeaderContainer_AfterScroll']: HeaderContainer_AfterScroll
};

